import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, ButtonGroup, ButtonList, DropdownButton, DropdownButtonContext, Tooltip, } from '@dixa/lib-shared-habla';
import { useMemo } from 'react';
import { twilioActions } from 'app/middleware/twilio/actions/twilioActions';
import { analytics } from 'app/utils/segment';
import { useAppDispatch } from 'utils/redux/useAppDispatch';
import { useAppSelector } from 'utils/redux/useAppSelector';
import styles from './contactCallAction.module.scss';
export function ContactCallAction({ user, }) {
    const dispatch = useAppDispatch();
    const isInPhoneConversation = !!useAppSelector((state) => state.presence.presence.presence_status.load_descriptions.find((item) => item.media_type === 'speak'));
    const { selectedFromNumber, isMicrophoneBlocked } = useAppSelector((state) => state.telephony);
    const canMakePhoneCall = !isInPhoneConversation && !isMicrophoneBlocked && !!selectedFromNumber;
    const disabledButtonTooltipText = useMemo(() => {
        if (!selectedFromNumber) {
            return 'Select a default outbound number in settings to enable phone calls';
        }
        if (isMicrophoneBlocked) {
            return 'Enable the microphone in your browser to enable phone calls';
        }
        if (isInPhoneConversation) {
            return 'End your current call before making new calls';
        }
        return '';
    }, [isInPhoneConversation, selectedFromNumber, isMicrophoneBlocked]);
    const handleClick = (phoneNumber) => {
        if (!phoneNumber)
            return;
        const { id } = user;
        if (canMakePhoneCall && selectedFromNumber) {
            dispatch(twilioActions.twilioMakeCall({
                userId: id,
                toNumber: phoneNumber,
                fromNumber: selectedFromNumber.e164_format,
            }));
            analytics.contactsCardMakeCallClicked();
        }
    };
    return (_jsxs(ButtonGroup, Object.assign({ variant: "secondary" }, { children: [_jsx(Tooltip, Object.assign({ content: disabledButtonTooltipText, disabled: canMakePhoneCall, dark: true, side: "left" }, { children: _jsx(Button, Object.assign({ icon: "phone", disabled: !canMakePhoneCall, onClick: () => handleClick(user.phone_number), variant: "secondary", className: styles.noBorderRadiusRight }, { children: "Call" })) })), user.additional_phone_numbers && (_jsx(DropdownButton, { icon: "angle-down", buttonProps: {
                    className: styles.dropdownButton,
                }, dropdown: _jsx(DropdownButtonContext.Consumer, { children: ({ toggleDropdown }) => {
                        var _a;
                        return (_jsxs(ButtonList, { children: [_jsx(ButtonList.Item, Object.assign({ onClick: () => {
                                        toggleDropdown();
                                        handleClick(user.phone_number);
                                    } }, { children: user.phone_number })), (_a = user.additional_phone_numbers) === null || _a === void 0 ? void 0 : _a.map((option) => (_jsx(ButtonList.Item, Object.assign({ onClick: () => {
                                        toggleDropdown();
                                        handleClick(option);
                                    } }, { children: option }), option)))] }));
                    } }) }))] })));
}
